/**
 * Meta-Vorgaben der Site.
 *
 * Eigenes Modul ohne `'use client'`, damit die Werte sowohl clientseitig
 * (`setMetaData()`) als auch aus einer Server-Komponente heraus gelesen werden
 * können — der Import einer `'use client'`-Datei liefert dort nur
 * Client-Referenzen und keine Werte.
 */
export type MetaTypeProps = 'website' | 'article';

export const defaultMetaData = {
  title: 'Vetopedia - Die freie Enzyklopädie der Gegenstimmen',
  description:
    'Hier finden geblockte Volk-Stimmen Gehör! Längst existieren unzählige wissenschaftliche Studien, die die Schädigung durch Impfungen, Mobilfunk usw. als definitiv gefährlich und gesundheitsschädigend nachgewiesen haben. Diese Studien werden aber von Kartellmedien, Politik, Justiz usw. konsequent verschwiegen oder sogar aktiv unterdrückt. Jetzt kommt das Volk zu Wort!',
  keywords: ['Impfschäden', 'Mobilfunkschäden', 'Pharmaopfer', 'Medizinopfer', 'Medien-Verleumdungen'],
  url: 'https://vetopedia.org',
  image: 'https://vetopedia.org/img/Logo_Frame.png',
  author: 'Vetopedia',
  type: 'website' as MetaTypeProps,
  locale: 'de_DE'
};
